export const halogenURL = (slug: string) => {
  return `${process.env.IS_DEV === 'true' ? '/halogen' : ''}/${slug}`;
};
